import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../../services/customer_appCommonService";
import logistics from "../../../../../services/logistics_appCommonService";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
import {
  validateRequired,
} from "../../../../../common/Validations";
import toast from "react-hot-toast";
import FileUploadComponent from "../../../../../Components/formElements/FileUploadComponent";
import Layout from "../../../../../Layout/Layout";
import FileViewerModal from "../../../../../Components/FileViewer/FileViewerModal";
import LogisticsConstants from "../../../../../common/LogisticsConstants";
import { validateDrivingLicence, validateRegistration, validateInsurance, validateFASTag, validatePollution } from "../../../../../common/Validations";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const CreateVehicle = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Vehicle");

  let userData = useSelector((state) => state?.user?.data);

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };


  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);


  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);

  //renewalDueOn
  const [getRenewalDueOn, setRenewalDueOn] = useState({
    statePermit: "",
    statePermitDate: "",
    nationalPermit: "",
    roadTax: "",
    fitness: "",
    insuranceNr: "",
    pollution: "",
    AMC: "",
    renewalCapacityMT: "",
    renewalNoOfTyres: "",
    tyrenumbers: "",
    insuranceExpiryDate: "",
    insuranceDate: "",
  })


  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);


  const [getdocumentType, setdocumentType] = useState([]);


  const [validation, setValidation] = useState({
    vehicleRegistrationNr: "",
    statePermit: "",

  });
  const typeOptions = [
    { id: 1, name: "Hired", textField: "type" },
    { id: 2, name: "Own", textField: "type" },
  ];
  const noOfTyresOptions = [
    { id: 1, name: "4", textField: "noOfTyres" },
    { id: 2, name: "6", textField: "noOfTyres" },
    { id: 3, name: "8", textField: "noOfTyres" },
    { id: 4, name: "10", textField: "noOfTyres" },
    { id: 5, name: "12", textField: "noOfTyres" },
    { id: 6, name: "14", textField: "noOfTyres" },
    { id: 7, name: "16", textField: "noOfTyres" },
    { id: 8, name: "18", textField: "noOfTyres" },
    { id: 9, name: "20", textField: "noOfTyres" },
    { id: 10, name: "22", textField: "noOfTyres" },
  ]
  const refVehicleOptions = [
    { id: 1, name: "Yes", textField: "type1" },
    { id: 2, name: "No", textField: "type1" },
  ];

  const statePermitOptions = [
    { name: "Yes", textField: "statePermit" },
    { name: "No", textField: "statePermit" }

  ]
  const nationalPermitOptions = [
    { name: "Yes", textField: "nationalPermit" },
    { name: "No", textField: "nationalPermit" }

  ]
 

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    vehicleRegistrationNr: "",
    registrationDate: "",
    manufactureMake: "",
    chassisNr: "",
    engineNr: "",
    capacityMT: "",
    noOfTyres: "",
    statePermit: "",
    statePermitDate: "",
    nationalPermit: "",
    nationalPermitDate: "",
    roadTax: "",
    type: "",
    transporter: "",
    ownername: "",
    makeModel: "",
    type1: "",
    refvehicleRegistrationNr: "",
    refregistrationDate: "",
    refmanufactureMake: "",
    refchassisNr: "",
    refmakeModel: "",
    refengineNr: "",
    refnoOfTyres: "",
    refownername: "",
    reftype: "",
    reftransporter: "",

    refstatePermit: "",
    refstatePermitDate: "",
    refnationalPermit: "",
    refnationalPermitDate: "",
    refroadTax: "",
    reffitness: "",
    refinsuranceNr: "",
    refinsuranceExpiryDate: "",
    refPollution: "",
    refAmc: "",


  });

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    // if (getDropdownData?.codeType === "country") {
    //   setFormInputs((formInputs) => ({
    //     ...formInputs,
    //     [getDropdownData?.textField]: getDropdownData?.name,
    //     [getDropdownData?.textCode]: getDropdownData?.code,
    //     [getDropdownData?.textDesc]: getDropdownData?.description,
    //   }));
    //   getStateData(getDropdownData?.code);
    // } else
     if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
              ...doc,
              [getDropdownData?.textField]: getDropdownData?.name,
              [getDropdownData?.textCode]: getDropdownData?.code,
              [getDropdownData?.textDesc]: getDropdownData?.description,
            }
            : doc
        )
      );
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const onInputChangerenewalDueOn = ({ target: { name, value } }) => {
    const errors = {};
    setRenewalDueOn((formInputs) => ({ ...formInputs, [name]: value }));

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));

  };

  // SAVE
  const handleSave = async () => {
    const requiredFields = [];
    let hasError = false;
    const validationErrors = {};

    const regNum = formInputs.vehicleRegistrationNr?.trim().toUpperCase();

    if (!validateRequired(regNum)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        vehicleRegistrationNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    } else if (!/^[A-Z]{2}\d{2}[A-Z]{1,2}\d{1,4}$/.test(regNum)) {
      const formatMessage = "Enter a valid Vehicle Registration Number (e.g., KA01AB1234)";
      requiredFields.push("Invalid Vehicle Registration Number");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        vehicleRegistrationNr: formatMessage,
      }));
      return;
    }

    if (!validateRequired(formInputs.registrationDate)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        registrationDate: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.manufactureMake)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        manufactureMake: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.chassisNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        chassisNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.engineNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        engineNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.noOfTyres)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        noOfTyres: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.capacityMT)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        capacityMT: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    getDocumentTypeData.forEach((doc) => {
      const id = doc.id;
      const type = doc.documentType?.trim();
      const number = doc.documentNumber?.trim();


      if (!number) {
        validationErrors[`${id}_documentNumber`] = message.FILL_REQUIRED_FIELD;
        requiredFields.push(message.FILL_REQUIRED_FIELD);
        hasError = true;
      } else {
        // Type-based format validation
        if (type === "700 - Driving Licence" && !validateDrivingLicence(number)) {
          validationErrors[`${id}_documentNumber`] = "Enter a valid Driving Licence number (e.g., MH122023000123456)";
          requiredFields.push("Invalid Driving Licence format");
          hasError = true;
        } else if (type === "701 - Registration/RTO" && !validateRegistration(number)) {
          validationErrors[`${id}_documentNumber`] = "Enter a valid Registration number (e.g., KA01AB1234)";
          requiredFields.push("Invalid Registration format");
          hasError = true;
        } else if (type === "702 - Insurance certificate" && !validateInsurance(number)) {
          validationErrors[`${id}_documentNumber`] = "Enter a valid Insurance Certificate number (10–20 alphanumeric characters)";
          requiredFields.push("Invalid Insurance format");
          hasError = true;
        } else if (type === "704 - FASTag" && !validateFASTag(number)) {
          validationErrors[`${id}_documentNumber`] = "Enter a valid FASTag number (e.g., IC123456789012)";
          requiredFields.push("Invalid FASTag format");
          hasError = true;
        } else if (type === "705 - Pollution certificate" && !validatePollution(number)) {
          validationErrors[`${id}_documentNumber`] = "Enter a valid Pollution Certificate number (8–15 alphanumeric characters)";
          requiredFields.push("Invalid Pollution Certificate format");
          hasError = true;
        }

      }
    });

    setValidation((prev) => ({
      ...prev,
      ...validationErrors,
    }));

    const anyFieldHasError = Object.values(validationErrors).some(
      (val) => val !== null && val !== ""
    );

    if (hasError || anyFieldHasError) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    // if (!validateRequired(setRenewalDueOn.statePermit)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     statePermit: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.nationalPermit)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     nationalPermit: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.roadTax)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     roadTax: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.fitness)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     fitness: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.insuranceNr)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     insuranceNr: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.pollution)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     pollution: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.AMC)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     AMC: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.renewalCapacityMT)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     renewalCapacityMT: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.renewalNoOfTyres)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     renewalNoOfTyres: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.tyreNumbers)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     tyreNumbers: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }


    const validDocs = getDocumentTypeData.filter((doc) =>
      doc.documentNumber && doc.issueDate
    );

    formInputs.firstName = formInputs.organisationName;
    formInputs.contactDetails = getcustomerContactPerson;
    formInputs.certifications = validDocs;
    formInputs.salesOfficerCode = userData?.userId;
    formInputs.salesOfficerName = userData?.firstName;
    

    formInputs.renewalDueOn = getRenewalDueOn;
    formInputs.contactDetails = getcustomerContactPerson;

    const obj = {
      data: formInputs,
    };
    setDisabled(true);
    await logistics.addTruckMaster(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(LogisticsConstants.LOGISTICS_MASTER_VEHICLE_LIST);

      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "VehicleDocType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
 

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };


  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  const handleChangeCustomerContacts = (id, fieldName, value) => {
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  

  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );

    // Clear the error when user corrects the input
    if (fieldName === 'documentNumber') {
      setValidation((prev) => ({
        ...prev,
        [`${id}_documentNumber`]: '',

      }));
    }

  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };


  //bank end
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Vehicle Registration</h2>
            <p className="subText">
              Register as a new Vehicle or Sub-Contractor with our Company
            </p>
            <hr />
            <Row className="mb-4">
              <Col
                xs={12}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
            </Row>
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">VR</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Vehicle </span>
                      <span className="subHeaderTitle">Vehicle Registration</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vehicle RegistrationNo"
                          name="vehicleRegistrationNr"
                          placeholder=""
                          value={formInputs.vehicleRegistrationNr || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.vehicleRegistrationNr}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Registration Date"
                          type="date"
                          name="registrationDate"
                          // min="2023-01-01"
                          // max="2023-12-31"
                          min={2023}
                          placeholder=""
                          value={formInputs.registrationDate || ""}
                          onChange={onInputChange}
                          error={validation.registrationDate}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Manufacture Make"
                          name="manufactureMake"
                          placeholder=""
                          value={formInputs.manufactureMake || ""}
                          onChange={onInputChange}
                          error={validation.manufactureMake}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Make Model"
                          name="makeModel"
                          placeholder=""
                          value={formInputs.makeModel || ""}
                          onChange={onInputChange}
                          error={validation.makeModel}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Chessis Number"
                          name="chassisNr"
                          placeholder=""
                          value={formInputs.chassisNr || ""}
                          onChange={onInputChange}
                          error={validation.chassisNr}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Engine Number"
                          name="engineNr"
                          placeholder=""
                          value={formInputs.engineNr || ""}
                          onChange={onInputChange}
                          error={validation.engineNr}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="No of Tyres"
                          placeholder=""
                          data={noOfTyresOptions}
                          id="noOfTyres"
                          iconClassName="dropdownIcon"
                          name="noOfTyres"
                          required={true}
                          setvalue={formInputs?.noOfTyres}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                        // disabled={getDisabledStatus}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Capacity MT"
                          name="capacityMT"
                          placeholder=""
                          value={formInputs.capacityMT || ""}
                          onChange={onInputChange}
                          error={validation.capacityMT}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Owner Name"
                          name="ownername"
                          placeholder=""
                          value={formInputs.ownername || ""}
                          onChange={onInputChange}
                          error={validation.ownername}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Type"
                          placeholder=""
                          data={typeOptions}
                          id="type"
                          iconClassName="dropdownIcon"
                          name="type"
                          required={true}
                          setValue={formInputs.type}
                          getvalue={setDropdownData}
                        // disabled={getDisabledStatus}
                        // className="dropdownOption"
                        />
                      </Col>
                      {formInputs.type === 'Hired' &&
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transporter"
                            name="transporter"
                            placeholder=""
                            setValue={formInputs?.transporter || ""}
                            onChange={onInputChange}
                            error={validation.transporter}
                            required={true}
                          />
                        </Col>

                      }
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Ref Vehicle"
                          placeholder=""
                          data={refVehicleOptions}
                          id="type1"
                          iconClassName="dropdownIcon"
                          name="type1"
                          required={true}
                          setValue={formInputs.type1}
                          getvalue={setDropdownData}
                        // disabled={getDisabledStatus}
                        // className="dropdownOption"
                        />
                      </Col>
 <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            <div>
                              <label
                                className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                htmlFor="activeInactive"
                              >
                                Active/Inactive
                              </label>
                            </div>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input custom-switch"
                                type="checkbox"
                                role="switch"
                                name="activeInactive"
                                id="activeInactive"
                                checked={formInputs?.activeInactive || false}
                                onChange={(e) =>
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    activeInactive: e.target.checked,
                                  }))
                                }
                                // disabled={editMode}
                              />
                              <span className="ms-2">
                                {formInputs?.activeInactive
                                  ? "Active"
                                  : "Inactive"}
                              </span>
                            </div>
                          </Col>


                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              setValue={doc?.contactPosition}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              setValue={doc?.contactTitle}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </Col>

                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4"
                                            />
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RD</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Renewal DueOn </span>
                      <span className="subHeaderTitle">Vehicle Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="State Permit"
                          name="statePermit"
                          id="statePermit"
                          placeholder="State Permit"
                          data={statePermitOptions}
                          iconClassName="dropdownIcon"
                          code="statePermitCode"
                          setValue={formInputs?.statePermit || ""}
                          onChange={onInputChangerenewalDueOn}
                          required={true}
                          getvalue={setDropdownData}
                        // error={validation.statePermit}
                        />
                      </Col>

                      {formInputs?.statePermit === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="State Permit Date"
                            name="statePermitDate"
                            id="statePermitDate"
                            min={2023}
                            // value={formInputs?.renewalDueOn?.statePermitDate || ""}
                            onChange={onInputChangerenewalDueOn}
                            required={true}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="National Permit"
                          name="nationalPermit"
                          id="nationalPermit"
                          placeholder="National Permit"
                          data={nationalPermitOptions}
                          iconClassName="dropdownIcon"
                          code="nationalPermitCode"
                          setValue={formInputs?.nationalPermit || ""}
                          onChange={onInputChangerenewalDueOn}
                          required={true}
                          getvalue={setDropdownData}
                        // error={validation.statePermit}
                        />
                      </Col>
                      {formInputs?.nationalPermit === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="National Permit Date"
                            name="nationalPermitDate"
                            id="nationalPermitDate"
                            min={2023}
                            // value={formInputs?.nationalPermitDate || ""}
                            onChange={onInputChangerenewalDueOn}
                            required={true}
                          />

                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Road Tax"
                          name="roadTax"
                          type="date"
                          placeholder=""
                          min={2023}
                          // value={formInputs?.renewalDueOn?.roadTax || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.roadTax}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Fitness"
                          name="fitness"
                          type="date"
                          min={2023}
                          placeholder=""
                          // value={formInputs?.renewalDueOn?.fitness || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.fitness}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Insurance"
                          name="insuranceNr"
                          placeholder=""
                          // value={formInputs?.renewalDueOn?.insuranceNr || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.insuranceNr}
                          required={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Insurance Date"
                          name="insuranceDate"
                          placeholder=""
                          type="date"
                          // value={formInputs?.renewalDueOn?.insuranceDate || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.insuranceDate}
                          required={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Insurance Expiry Date"
                          name="insuranceExpiryDate"
                          placeholder=""
                          type="date"
                          min={2023}
                          // value={formInputs?.renewalDueOn?.insuranceExpiryDate || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.insuranceExpiryDate}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Pollution"
                          name="pollution"
                          placeholder=""
                          // value={formInputs?.renewalDueOn?.pollution}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.pollution}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="AMC"
                          name="AMC"
                          placeholder=""
                          type="date"
                          min={2023}
                          // value={formInputs?.renewalDueOn?.AMC}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.AMC}
                          required={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Renewal Capacity"
                          name="renewalCapacityMT"
                          placeholder=""
                          // value={formInputs?.renewalDueOn?.renewalCapacityMT}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.renewalCapacityMT}
                          required={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Renewal No of Tyres"
                          placeholder=""
                          data={renewalNoOfTyresOptions}
                          id="noOfTyres"
                          iconClassName="dropdownIcon"
                          name="renewalNoOfTyres"
                          required={true}
                          // onChange={onInputChange}
                          // value={formInputs?.renewalNoOfTyres}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.renewalNoOfTyres}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tyre Numbers"
                          name="tyreNumbers"
                          placeholder=""
                          // value={formInputs?.renewalDueOn?.tyreNumbers}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.tyreNumbers}
                          required={true}
                        />
                      </Col> */}


                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value, doc.type
                                              )
                                            }
                                            error={
                                              validation[
                                              `${doc.id}_documentNumber`
                                              ]
                                            }

                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.issueDate}
                                            min={2023}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        {/* <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Issuing Authority"
                                            value={doc.issuingAuthority}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issuingAuthority",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col> */}
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col>
                                      </Row>

                                    ))}

                                  </div>
                                </div>
                              </Col>
                            </Row>

                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {formInputs.type1 === "Yes" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RV</span>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        <span className="headerTitle">Ref Vehicle </span>
                        <span className="subHeaderTitle">Ref Vehicle Registration</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vehicle RegistrationNo"
                            name="refvehicleRegistrationNr"
                            placeholder=""
                            value={formInputs.refvehicleRegistrationNr || ""}
                            onChange={onInputChange}
                            // required={true}
                            error={validation.refvehicleRegistrationNr}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Registration Date"
                            type="date"
                            name="refregistrationDate"
                            // min="2023-01-01"
                            // max="2023-12-31"
                            min={2023}
                            placeholder=""
                            value={formInputs.refregistrationDate || ""}
                            onChange={onInputChange}
                            error={validation.refregistrationDate}
                          // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Manufacture Make"
                            name="refmanufactureMake"
                            placeholder=""
                            value={formInputs.refmanufactureMake || ""}
                            onChange={onInputChange}
                            error={validation.refmanufactureMake}
                          // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Make Model"
                            name="refmakeModel"
                            placeholder=""
                            value={formInputs.refmakeModel || ""}
                            onChange={onInputChange}
                            error={validation.refmakeModel}
                          // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Chessis Number"
                            name="refchassisNr"
                            placeholder=""
                            value={formInputs.refchassisNr || ""}
                            onChange={onInputChange}
                            error={validation.refchassisNr}
                          // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Engine Number"
                            name="refengineNr"
                            placeholder=""
                            value={formInputs.refengineNr || ""}
                            onChange={onInputChange}
                            error={validation.refengineNr}
                          // required={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="No of Tyres"
                            placeholder=""
                            data={noOfTyresOptions}
                            id="noOfTyres"
                            iconClassName="dropdownIcon"
                            name="refnoOfTyres"
                            required={true}
                            setvalue={formInputs?.refnoOfTyres}
                            onChange={onInputChange}
                            getvalue={setDropdownData}
                          // disabled={getDisabledStatus}
                          // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Capacity MT"
                            name="refcapacityMT"
                            placeholder=""
                            value={formInputs.refcapacityMT || ""}
                            onChange={onInputChange}
                            error={validation.refcapacityMT}
                          // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Owner Name"
                            name="refownername"
                            placeholder=""
                            value={formInputs.refownername || ""}
                            onChange={onInputChange}
                            error={validation.refownername}
                          // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Type"
                            placeholder=""
                            data={typeOptions}
                            id="type"
                            iconClassName="dropdownIcon"
                            name="reftype"
                            required={true}
                            setValue={formInputs.reftype}
                            getvalue={setDropdownData}
                          // disabled={getDisabledStatus}
                          // className="dropdownOption"
                          />
                        </Col>
                        {formInputs.reftype === 'Hired' &&
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Transporter"
                              name="reftransporter"
                              placeholder=""
                              setValue={formInputs?.reftransporter || ""}
                              onChange={onInputChange}
                              error={validation.reftransporter}
                            // required={true}
                            />
                          </Col>

                        }

                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {formInputs.type1 === "Yes" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RD</span>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        <span className="headerTitle">Ref Renewal DueOn </span>
                        <span className="subHeaderTitle">Ref Vehicle Details</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="State Permit"
                            name="refstatePermit"
                            id="statePermit"
                            placeholder="State Permit"
                            data={statePermitOptions}
                            iconClassName="dropdownIcon"
                            code="statePermitCode"
                            setValue={formInputs?.refstatePermit || ""}
                            onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            getvalue={setDropdownData}
                          // error={validation.statePermit}
                          />
                        </Col>

                        {formInputs?.refstatePermit === "Yes" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="State Permit Date"
                              name="refstatePermitDate"
                              id="statePermitDate"
                              min={2023}
                              // value={formInputs?.renewalDueOn?.statePermitDate || ""}
                              onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="National Permit"
                            name="refnationalPermit"
                            id="nationalPermit"
                            placeholder="National Permit"
                            data={nationalPermitOptions}
                            iconClassName="dropdownIcon"
                            code="nationalPermitCode"
                            setValue={formInputs?.refnationalPermit || ""}
                            onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            getvalue={setDropdownData}
                          // error={validation.statePermit}
                          />
                        </Col>
                        {formInputs?.refnationalPermit === "Yes" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="National Permit Date"
                              name="nationalPermitDate"
                              id="nationalPermitDate"
                              min={2023}
                              // value={formInputs?.nationalPermitDate || ""}
                              onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            />

                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Road Tax"
                            name="refroadTax"
                            type="date"
                            placeholder=""
                            min={2023}
                            // value={formInputs?.renewalDueOn?.roadTax || ""}
                            onChange={onInputChangerenewalDueOn}
                            error={validation.refroadTax}
                          //  required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Fitness"
                            name="reffitness"
                            type="date"
                            min={2023}
                            placeholder=""
                            // value={formInputs?.renewalDueOn?.fitness || ""}
                            onChange={onInputChangerenewalDueOn}
                            error={validation.reffitness}
                          //  required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Insurance"
                            name="refinsuranceNr"
                            placeholder=""
                            // value={formInputs?.renewalDueOn?.insuranceNr || ""}
                            onChange={onInputChangerenewalDueOn}
                            error={validation?.refinsuranceNr}
                          //  required={true}
                          />
                        </Col>                      
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Insurance Expiry Date"
                            name="refinsuranceExpiryDate"
                            placeholder=""
                            type="date"
                            min={2023}
                            // value={formInputs?.renewalDueOn?.insuranceExpiryDate || ""}
                            onChange={onInputChangerenewalDueOn}
                            error={validation.refinsuranceExpiryDate}
                          //  required={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Pollution"
                            name="refPollution"
                            placeholder=""
                            // value={formInputs?.renewalDueOn?.pollution}
                            onChange={onInputChangerenewalDueOn}
                            error={validation?.refPollution}
                          //  required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="AMC"
                            name="refAmc"
                            placeholder=""
                            type="date"
                            min={2023}
                            // value={formInputs?.renewalDueOn?.AMC}
                            onChange={onInputChangerenewalDueOn}
                            error={validation.refAmc}
                          //  required={true}
                          />
                        </Col>                 

                      </Row>
                    </div>
                  </div>
                </div>
              </div>

            )}
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col
          xs={12}
          md={{ span: 2, offset: 10 }}
          lg={{ span: 2, offset: 10 }}
          className="text-left"
        >
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CreateVehicle;
